import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  DataListModel,
  ApplicationRouteURL,
  WeGoAuthorizedLink,
  Permission,
  PermissionType,
  IKeyValueInterface
} from "./../../shared/config";
import { PrePostTripQuestionOverviewService } from "../models/pre-post-question-overview.service";
import { PrePostQuestionSearchModel } from "../models/pre-post-question-search.model";
import { PrePostQuestionInformationModel } from "../models/pre-post-question-information.model";
import { TranslateService } from "../../shared/translate";

const moment = require("moment");

@Component({
  selector: "wego-pre-post-questions-overview",
  template: require('../views/pre-post-trip-question-overview.components.html'),
  providers: [PrePostTripQuestionOverviewService]
})
export class PrePostQuestionsOverviewComponent implements OnInit {
  urlBookingInformation: string;
  apiErrorMsg: any;
  errorModel: IKeyValueInterface[];
  isLoading: boolean;
  DataListModel: DataListModel;
  urlDefaultPage: string;
  model: PrePostQuestionSearchModel;
  prePostQuestionList: PrePostQuestionInformationModel[];
  editText:string;

  constructor(
    private authService: AuthService,
    private prePostTripQuestionOverviewService: PrePostTripQuestionOverviewService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.model = new PrePostQuestionSearchModel();

    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );

    this.urlBookingInformation = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INFORMATION
    );
    this.DataListModel = new DataListModel();
    this.GetPrePostQuestionOverviewList();

    // this.model.startDateTime = moment().format("DD-MM-YYYY 00:00");
    // this.model.endDateTime = moment().add(+1, "M").format("DD-MM-YYYY 00:00");
  }

  // public OnGetData(event: any){
  //   this.GetPrePostQuestionOverviewList();
  // }
  editItem: any;
  private GetPrePostQuestionOverviewList() {
    this.prePostTripQuestionOverviewService
      .GetPrePostTripQuestionList(this.model, this.DataListModel)
      .subscribe(
        res => {
          if (res.data) {
            this.prePostQuestionList = res.data;
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = res.error;
            this.isLoading = false;
            this.errorModel = null;
          } else {
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = this.translate.instant(
              "LblNoRecords"
            );
            this.errorModel = res.error;
            this.isLoading = false;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetPrePostQuestionOverviewList();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetPrePostQuestionOverviewList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.prePostTripQuestionOverviewService
      .ExportPrePostTripQuestionList(this.model, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName =
              "PrePostQuestionOverviewList" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnAdvancedSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      "",
      event.isReset
    );
    if (!event.isReset) {
      this.model = event.prePostSearchFilterModel;
    } else {
      this.model.startDateTime = moment()
        .add(+1, "days")
        .format("DD-MM-YYYY 00:00");
      this.model.endDateTime = moment()
        .add(-1, "M")
        .format("DD-MM-YYYY 00:00");
      this.model = null;
    }
    this.GetPrePostQuestionOverviewList();
  }

  public OnAdvancedReset($event: any) {
    this.model = $event.prePostSearchFilterModel;
    this.GetPrePostQuestionOverviewList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetPrePostQuestionOverviewList();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/pre-post-trip-question-overview/components/pre-post-trip-question-overview.components.ts